export default __webpack_public_path__ + "static/media/l.4d9f512a.mp4";